import React from "react";
import ReactDOM from "react-dom";
import classes from "./input_modal.module.css";
// Import design utility primitives (buttons, surfaces, layout)
import util from "../../../styles/utilities.module.css";

const InputModal = ({ modalProps, InputComponent, inputProps }) => {
    const { isOpen, description, leftBtnHandler, rightBtnHandler, buttons } = modalProps;
    const { leftBtn, rightBtn } = buttons;

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`${classes["modal-overlay"]} ${util.modalOverlay || ""}`.trim()}>
            <div className={`${classes.modal} ${util.modalSurface || ""}`.trim()}>
                <h4 className={classes.body}>{description}</h4>
                {/* Render the input component if provided */}
                {InputComponent && <InputComponent key="input-modal-comp" {...inputProps} />}
                <div className={classes.confirmationBtnContainer}>
                    {leftBtn && (
                        <button
                            onClick={leftBtnHandler}
                            type="button"
                            className={`${util.btn} ${util['btn--ghost']} ${classes.pairBtn}`}
                        >
                            {leftBtn}
                        </button>
                    )}
                    {rightBtn && (
                        <button
                            onClick={rightBtnHandler}
                            type="button"
                            className={`${util.btn} ${util['btn--primary']} ${classes.pairBtn}`}
                        >
                            {rightBtn}
                        </button>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default InputModal;
